/* ===================== KanpoNow 相対URL運用・完全差し替え版（DOM分割リンク版 / FIX） ===================== */
/* 目的：
  - /pages/kanpo-xxxx の「成分（生薬）」(例: 茵蔯蒿、山梔子、大黄) を確実に自動リンク
  - Shopifyプレビュー(.shopifypreview.com) でもリンク先を本番へ寄せる（外部リンクは触らない）
  - 目次/見出し/特定ブロックは自動リンク対象外
  - 内部遷移でスクロール位置を復元
*/

/* === クリックガード：アンカーは素通り。相対URLでもプレビュー→本番へ安全に寄せる === */
(function clickGuardIIFE(){
  'use strict';
  const FALLBACK_ORIGIN = 'https://kanponow.com';

  function getCanonicalOrigin(){
    try{
      const ln = document.querySelector('link[rel="canonical"]');
      if (ln && ln.href) {
        const o = new URL(ln.href, location.href).origin;
        if (/\.shopifypreview\.com$/i.test(new URL(o).hostname)) return FALLBACK_ORIGIN;
        return o;
      }
    }catch(_){}
    return /\.shopifypreview\.com$/i.test(location.hostname) ? FALLBACK_ORIGIN : location.origin;
  }
  function isHashOnly(href){ return typeof href === 'string' && href.trim().startsWith('#'); }

  document.addEventListener('click', function (e) {
    const a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    const rawHref = a.getAttribute('href') || '';
    if (isHashOnly(rawHref)) return;

    try {
      const url = new URL(a.href, location.href);

      // 同一ページ + #アンカー（/path#id）は完全スルー
      if (url.origin === location.origin &&
          url.pathname === location.pathname &&
          url.hash && url.hash.startsWith('#')) {
        return;
      }

      // 相対 or 同一オリジンのみ処理（外部は触らない）
      const isRelative   = !/^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(rawHref);
      const isSameOrigin = url.origin === location.origin;

      if (isRelative || isSameOrigin) {
        const cOrigin = getCanonicalOrigin();
        if (cOrigin !== url.origin) {
          e.preventDefault();
          const dest = new URL(url.pathname + url.search + url.hash, cOrigin);
          location.assign(dest.href);
          return;
        }
      }
    } catch (_) {}
  }, true);
})();

/* ===== KanpoNow 自動リンク & スクロール復元（相対URL運用） ===== */
try { history.scrollRestoration = 'manual'; } catch (_) {}

/* -------------------- 小ユーティリティ -------------------- */
function parseKeywordList(text){
  const list=[]; if(!text) return list;
  for(const raw of text.split(/\r?\n/)){
    const line = raw.trim();
    if(!line || line.startsWith('#')) continue;
    const i = line.indexOf(':') >= 0 ? line.indexOf(':') : line.indexOf('：');
    if(i < 0) continue;
    const left = line.slice(0,i).trim();
    const url  = line.slice(i+1).trim();
    if(!left || !url) continue;
    const variants = left.split(/[，,]/).map(s => s.trim()).filter(Boolean);
    for(const word of variants){ list.push({ word, url }); }
  }
  return list;
}

function knNormalizePath(u){
  try{
    const a=new URL(u,location.origin);
    let p=a.pathname; if(p.length>1 && p.endsWith('/')) p=p.slice(0,-1);
    return p||'/';
  }catch(_){
    let p=String(u||'').split('#')[0].split('?')[0];
    if(!p.startsWith('/')) p='/'+p;
    if(p.length>1 && p.endsWith('/')) p=p.slice(0,-1);
    return p||'/';
  }
}

function escapeRegExp(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

/* -------------------- 除外マーキング（ページ編集不要） -------------------- */
function markExclusions(){
  // 既存の明示ブロック
  document.querySelectorAll('.kanponow-wrap, .kn-8types').forEach(el=>{
    el.setAttribute('data-kn-autolink','off');
  });

  // 目次系
  document.querySelectorAll('nav[aria-label*="目次"], [aria-label*="目次"], .toc, .toc-list').forEach(el=>{
    el.setAttribute('data-kn-autolink','off');
  });

  // 見出し系（タイトル含む）
  document.querySelectorAll('h1, h2, h3, .article-template__title, .main-page-title, .page-title, .section-header__title')
    .forEach(el=> el.setAttribute('data-kn-autolink','off'));

  // レコメンド系
  document.querySelectorAll('.product-recommendations, .related-products, .you-may-like, .cross-sell, [data-product-recommendations]')
    .forEach(el=> el.setAttribute('data-kn-autolink','off'));

  // 追加除外（HTML側で指定できるように）
  try{
    const extra = (window.KN_EXCLUDE_SELECTORS || '').trim();
    if(extra){
      document.querySelectorAll(extra).forEach(el=>{
        el.setAttribute('data-kn-autolink','off');
      });
    }
  }catch(_){}
}

/* -------------------- 既存リンクの事前カウント（単語ごと合算） -------------------- */
function precountExistingByWord(roots, entries){
  const counters = new Map(); // key: `${word}`
  for (const {word} of entries){
    const key = `${word}`;
    let count = 0;
    for (const root of roots){
      root.querySelectorAll('a[href]').forEach(a=>{
        try{
          const txt = (a.textContent || '').trim();
          if (!txt) return;
          if (txt.indexOf(word) !== -1) count++;
        }catch(_){}
      });
    }
    if (count) counters.set(key, count);
  }
  return counters;
}

/* -------------------- DOM分割型：TextNode を Fragment に置換してリンク挿入 -------------------- */
let KN_LINK_SEQ = 0;

/* FIXポイント：
  - 生薬の列挙「茵蔯蒿、山梔子、大黄」のように読点「、」区切りを確実に境界として扱う
  - 全角/半角括弧、句読点、スラッシュ等も境界扱い
*/
function buildBoundary(word){
  const safe = escapeRegExp(word);
  const boundaryClass = `[\\s　、,，。．・：:;!?！？」』）\\)】\\]›>＜＜>／/\\\\\\n\\r\\t]`;
  return {
    re: new RegExp(safe, 'g'),
    boundaryRe: new RegExp(boundaryClass)
  };
}
function isBoundaryChar(ch, boundaryRe){
  if (ch == null) return true; // 行頭行末扱い
  return boundaryRe.test(ch);
}

// 1つの TextNode に対して、1つの (word,url) を「最大remain回」だけリンク化
function linkifyTextNodeOnce(textNode, word, url, remain){
  if (remain <= 0) return 0;
  const text = textNode.nodeValue;
  if (!text || text.indexOf(word) === -1) return 0;

  const { re, boundaryRe } = buildBoundary(word);
  const frag = document.createDocumentFragment();

  let lastIndex = 0;
  let made = 0;

  let m;
  while ((m = re.exec(text)) !== null) {
    if (made >= remain) break;

    const start = m.index;
    const end   = start + word.length;

    const prevChar = start > 0 ? text[start - 1] : null;
    const nextChar = end < text.length ? text[end] : null;

    // 前後境界判定（ここが “成分（生薬）” を確実に拾うコア）
    if (!isBoundaryChar(prevChar, boundaryRe) || !isBoundaryChar(nextChar, boundaryRe)) {
      continue;
    }

    if (start > lastIndex) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));
    }

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('data-restore', '1');
    a.setAttribute('data-kn-restore-seq', String(++KN_LINK_SEQ));
    a.textContent = word;
    frag.appendChild(a);

    made++;
    lastIndex = end;
  }

  if (made === 0) return 0;

  if (lastIndex < text.length) {
    frag.appendChild(document.createTextNode(text.slice(lastIndex)));
  }

  textNode.parentNode.replaceChild(frag, textNode);
  return made;
}

function autolinkKeywordsDOM(rootEl, entries, maxPerWord, counters){
  if(!rootEl || !entries.length) return;
  counters = counters || new Map();

  const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, {
    acceptNode(n){
      if(!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      let p = n.parentElement;
      while(p){
        // data-kn-autolink="off" が付いた領域は完全除外
        if(p.matches?.('a, script, style, noscript, code, pre, [data-kn-autolink="off"]')) {
          return NodeFilter.FILTER_REJECT;
        }
        p = p.parentElement;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  });

  // 長い語を先に処理（部分一致誤リンク防止）
  const sorted = entries.slice().sort((a,b)=>b.word.length - a.word.length);

  // walker中にDOMが変わるので、まずTextNodeを配列化
  const textNodes = [];
  while(walker.nextNode()) textNodes.push(walker.currentNode);

  for (const t of textNodes) {
    if (!t.parentNode) continue;

    for (const {word, url} of sorted){
      const key     = `${word}`;
      const already = counters.get(key) || 0;
      const remain  = maxPerWord ? Math.max(0, maxPerWord - already) : Infinity;
      if (!remain) continue;

      const made = linkifyTextNodeOnce(t, word, url, remain);
      if (made > 0) {
        counters.set(key, already + made);
        break; // このTextNodeは置換されるので次へ
      }
    }
  }
}

/* -------------------- スクロール位置復元 -------------------- */
const STACK_KEY_PREFIX="kn_stack:", SAVE_TTL_MS=10*60*1000;
let KN_LAST_SAVE_AT=0;
const stackKey=()=>STACK_KEY_PREFIX+knNormalizePath(location.href);
const readStack=()=>{const raw=sessionStorage.getItem(stackKey()); if(!raw) return []; try{const arr=JSON.parse(raw); return Array.isArray(arr)?arr:[];}catch{return [];}}; // eslint-disable-line
const writeStack=arr=>{try{sessionStorage.setItem(stackKey(),JSON.stringify(arr));}catch{}}; // eslint-disable-line
const pushStack=rec=>{const a=readStack(); a.push(rec); writeStack(a);};
const peekStack=()=>{const a=readStack(); return a.length?a[a.length-1]:null;};
const popStack=()=>{const a=readStack(); const r=a.pop()||null; writeStack(a); return r;};

function isInternalLink(a){try{return new URL(a.href,location.origin).origin===location.origin;}catch(_){return false;}}
function ignoreClick(ev){return ev.defaultPrevented||ev.button!==0||ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey;}
function saveOnNavigate(seq=null){
  const now=Date.now(); if(now-KN_LAST_SAVE_AT<120) return; KN_LAST_SAVE_AT=now;
  pushStack({ y: window.scrollY, seq, ts: now });
}
document.addEventListener("click", ev=>{
  const a=ev.target.closest?.("a"); if(!a||ignoreClick(ev)||!isInternalLink(a)||a.target==="_blank") return;
  const seq=a.getAttribute("data-kn-restore-seq"); saveOnNavigate(seq?Number(seq):null);
}, true);
window.addEventListener("pagehide", ()=>saveOnNavigate(null), {capture:true});
document.addEventListener("visibilitychange", ()=>{ if(document.visibilityState==="hidden") saveOnNavigate(null); });

function instant(fn){
  const root=document.documentElement, prev=root.style.scrollBehavior;
  root.style.scrollBehavior='auto';
  try{ fn(); } finally { setTimeout(()=>{root.style.scrollBehavior=prev;},400); }
}
function restoreFromEntry(entry){
  if(entry.seq!=null){
    let tries=0, max=18;
    const step=()=>{
      const el=document.querySelector(`[data-kn-restore-seq="${entry.seq}"]`);
      if(el){
        tries++; instant(()=>el.scrollIntoView({block:'start', inline:'nearest'}));
        if(tries<max && Math.abs(el.getBoundingClientRect().top)>2){ setTimeout(step,50); }
        else { popStack(); }
        return true;
      }
      if(tries<6){ tries++; setTimeout(step,50); return true; }
      return false;
    };
    if(step()) return true;
  }
  let tries=0, max=14, targetY=Math.max(0, parseInt(entry.y,10)||0);
  const snap=()=>{
    tries++; window.scrollTo(0,targetY);
    if(Math.abs(window.scrollY-targetY)>2 && tries<max){ setTimeout(snap,50); }
    else { popStack(); }
  };
  instant(()=>setTimeout(snap,0));
  return true;
}
function restoreOnPageShow(){
  const top=peekStack(); if(!top) return;
  const fresh=(Date.now()-(top.ts||0))<SAVE_TTL_MS;
  if(!fresh){ popStack(); return; }
  restoreFromEntry(top);
}
function restoreOnDOMContentLoaded(){
  const top=peekStack(); if(!top) return;
  let sameOriginRef=false;
  try{
    sameOriginRef=!!document.referrer && new URL(document.referrer,location.origin).origin===location.origin;
  }catch(_){}
  const fresh=(Date.now()-(top.ts||0))<SAVE_TTL_MS;
  if(!(sameOriginRef&&fresh)) return;
  restoreFromEntry(top);
}

/* -------------------- 起動：①除外 → ②本文リンク → ③復元 -------------------- */
window.addEventListener("pageshow", restoreOnPageShow);

function getRoots(){
  const scope = (window.KN_SCOPE_SELECTORS || '').trim();
  const selectors = scope
    ? scope.split(',').map(s=>s.trim()).filter(Boolean)
    : ['.page-width .rte', '.article-template__content .rte', '.article-template__content', '.rte', 'main'];

  const seen = new Set();
  const roots = [];
  for (const sel of selectors){
    document.querySelectorAll(sel).forEach(el=>{
      if(!el || seen.has(el)) return;
      if(el.closest?.('[data-kn-autolink="off"]')) return;
      seen.add(el);
      roots.push(el);
    });
  }
  if(!roots.length) roots.push(document.body);
  return roots;
}

function runAutolink(){
  markExclusions();

  const all  = parseKeywordList(window.KN_KEYWORDS_TEXT||"");
  const maxW = Number(window.KN_MAX_LINKS_PER_WORD||0) || 0; // 1推奨 / 0は無制限
  const here = knNormalizePath(location.href);
  const entries = all.filter(({url})=>knNormalizePath(url)!==here && url); // 自己リンク除外

  if(!entries.length) return;

  const roots = getRoots();
  const counters = precountExistingByWord(roots, entries);

  roots.forEach(el=>autolinkKeywordsDOM(el, entries, maxW, counters));
}

document.addEventListener("DOMContentLoaded", ()=>{
  runAutolink();
  restoreOnDOMContentLoaded();

  // Shopifyで本文が遅れて入るケース対策：少し遅延でもう一回
  setTimeout(runAutolink, 250);
  setTimeout(runAutolink, 900);

  // さらに、数秒だけ監視して後から挿入される本文にも対応（重くしないため時間制限）
  try{
    let stopAt = Date.now() + 5000; // 5秒だけ
    const mo = new MutationObserver(()=>{
      if(Date.now() > stopAt){
        try{ mo.disconnect(); }catch(_){}
        return;
      }
      runAutolink();
    });
    mo.observe(document.body, { childList:true, subtree:true });
    setTimeout(()=>{ try{ mo.disconnect(); }catch(_){} }, 5500);
  }catch(_){}
});
/* ===================== /KanpoNow 相対URL運用・完全差し替え版（DOM分割リンク版 / FIX） ===================== */